import { Injectable } from '@angular/core';

import {
    PcvizCompassTool,
    PcvizGridTool,
    PcvizHelperArrowTool,
    PcvizHighlightFeatureTool,
    PcvizJobSiteSceneView,
    PcvizPrismPoleTool,
    PcvizSceneView,
    PcvizSmartPointsTool,
    PcvizViewer,
} from '@mirage-projects/cw-models';

@Injectable({
    providedIn: 'root',
})
export class RenderToolsPcvizService {
    createGridTool(viewer: PcvizViewer): PcvizGridTool {
        return new PointCloudViz.RenderTools.GridTool(viewer);
    }

    createCompassTool(viewer: PcvizViewer): PcvizCompassTool {
        return new PointCloudViz.RenderTools.CompassTool(viewer);
    }

    createHighlightFeatureTool(view: PcvizSceneView | PcvizJobSiteSceneView): PcvizHighlightFeatureTool {
        return new PointCloudViz.RenderTools.HighlightFeatureTool(view);
    }

    createPrismPoleTool(view: PcvizSceneView): PcvizPrismPoleTool {
        return new PointCloudViz.RenderTools.PrismPoleTool(view);
    }

    createSmartPointsTool(view: PcvizSceneView): PcvizSmartPointsTool {
        return new PointCloudViz.RenderTools.SmartPointsTool(view);
    }

    createHelperArrowTool(viewer: PcvizSceneView): PcvizHelperArrowTool {
        return new PointCloudViz.RenderTools.HelperArrowTool(viewer);
    }
}
